import React from 'react';
import classNames from 'classnames';
import { useTranslation } from '../../../../i18n/use-translation';
import * as styles from './auth.module.sass';
import { AuthContainerProps } from './type/props';
import { useViewModel } from './hook/use-view-model';
import { useConfig } from '../../../../config/context';

export const AuthContainer = (props: AuthContainerProps) => {
  const { t } = useTranslation();
  const { redirectToRegisterHandler, redirectToLoginHandler, loginClickHandler, registerClickHandler } = useViewModel();


  return (
    <div className={classNames(styles.btn_auth_container, props.className)}>
      <button name="sign_in" onClick={redirectToLoginHandler}>
        {t('sign_in')}
      </button>
      |
      <button name="register" onClick={redirectToRegisterHandler}>
        {t('register')}
      </button>
    </div>
  );
};
